import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { BaseFilterProps } from "../types";

/**
 * Language filter component with flag emoji support.
 * Renders a list of languages with their flags and checkboxes.
 */
export function LanguageFilter({
  filter,
  config,
  onValueChange,
}: Omit<BaseFilterProps, 'isActive' | 'onToggle' | 'onRemove'>) {
  return (
    <>
      {config.options?.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer hover:bg-muted p-2 rounded"
        >
          <Checkbox
            checked={filter.values.includes(option.value)}
            onCheckedChange={() => onValueChange(option.value)}
          />
          {option.flag && <span className="text-lg">{option.flag}</span>}
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </>
  );
}

export default LanguageFilter;

